import { common } from '@mui/material/colors';

import type { Spacing } from '@mui/system/createTheme/createSpacing';
import type { Theme, SxProps, Palette } from '@mui/material';

export const buttonSx = (primary?: boolean, sx: SxProps<Theme> = []): SxProps<Theme> => {
  return [
    ({ palette, spacing }: { palette: Palette; spacing: Spacing }) => ({
      color: palette.primary.main,
      background: primary ? palette.secondary.main : common.white,
      borderColor: palette.primary.main,
      fontWeight: 700,
      minHeight: spacing(5),
      boxShadow: 'none',
      fontSize: 14,
      '&:hover': {
        background: primary ? palette.secondary.dark : palette.primary.main,
        color: primary ? palette.primary.main : common.white,
        boxShadow: 'none',
      },
      '&:active': {
        background: primary ? palette.secondary.light : palette.primary.dark,
        color: primary ? palette.primary.main : palette.common.white,
        boxShadow: 'none',
      },
      '&:focus:not(:active)': {
        outline: `3px solid ${palette.primary.light}`,
      },
    }),
    ...(Array.isArray(sx) ? sx : [sx]),
  ];
};
